import { render, staticRenderFns } from "./SuspendCustomerDialog.vue?vue&type=template&id=3a46e7b6"
import script from "./SuspendCustomerDialog.vue?vue&type=script&lang=js"
export * from "./SuspendCustomerDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports